import { useMemo } from 'react';
import * as React from 'react';

import {
  MultiracePercentageOfBets,
  MultiraceType,
} from '@/lib/apollo/types/gen/graphql';

import { BorderData } from '../style';
import { BarWrapper, Field, PercentageBar, Wrapper } from './style';

interface PercentageOfBetsProps {
  bicycleNum: number;
  multiracePercentageOfBets: MultiracePercentageOfBets[];
  singleRacePercentageOfBets: number;
  multiraceType: MultiraceType;
}

const PercentageOfBetsData: React.FC<PercentageOfBetsProps> = ({
  bicycleNum,
  multiracePercentageOfBets,
  singleRacePercentageOfBets,
  multiraceType,
}) => {
  const mPoB = useMemo(() => {
    const target = multiracePercentageOfBets.find(
      pob => pob.multiraceType === multiraceType,
    );
    if (target) {
      return target.percentageOfBets;
    }
    return 0;
  }, [multiracePercentageOfBets, multiraceType]);

  return (
    <BorderData isBorderRightNone>
      <Wrapper>
        <Field>
          <span>状況</span>
          <BarWrapper>
            <PercentageBar
              now={mPoB}
              bicycleNum={bicycleNum}
              data-testid="multirace-percentage-bar"
            />
            <span data-testid="multirace-percentage">{mPoB}%</span>
          </BarWrapper>
        </Field>
        <Field>
          <span>支持</span>
          <BarWrapper>
            <PercentageBar
              now={singleRacePercentageOfBets}
              bicycleNum={bicycleNum}
              alpha={0.6}
              data-testid="singlerace-percentage-bar"
            />
            <span data-testid="singlerace-percentage">
              {singleRacePercentageOfBets}%
            </span>
          </BarWrapper>
        </Field>
      </Wrapper>
    </BorderData>
  );
};

export default PercentageOfBetsData;
